// extracted by mini-css-extract-plugin
export default {"textarea":"u3zETdb","label":"wNiNjzp"};